import { z } from 'zod';

// Contratos del libro de reprocesos (so=380) validados con Zod: las devoluciones de un
// documento y las de una persona. Una respuesta con otra forma cae al error de su
// tarjeta, nunca a una excepción en el render.

const ROLES = ['elaborador', 'revisor', 'aprobador', 'capacitador'] as const;

export const reworkEventSchema = z.object({
  id: z.string(),
  occurredAt: z.string(),
  entryId: z.string(),
  code: z.string().nullable(),
  fromStatus: z.string(),
  toStatus: z.string(),
  attributedRole: z.enum(ROLES),
  originatorUserId: z.string().nullable(),
  originatorName: z.string().nullable(),
  attributionSource: z.enum(['responsable_asignado', 'mayor_esfuerzo', 'sin_atribuir']),
  returnedById: z.string(),
  returnedByName: z.string().nullable(),
  reason: z.string(),
  effortSeconds: z.number(),
  activeUnionSeconds: z.number(),
});
export type ReworkEvent = z.infer<typeof reworkEventSchema>;

export const participantSchema = z.object({
  userId: z.string().nullable(),
  role: z.enum(ROLES),
  reworkCount: z.number(),
  name: z.string().nullable(),
});
export type Participant = z.infer<typeof participantSchema>;

export const entryReworkResponseSchema = z.object({
  success: z.literal(true),
  data: z.object({
    entryId: z.string(),
    code: z.string(),
    events: z.array(reworkEventSchema),
    eventsTruncated: z.boolean(),
    participants: z.array(participantSchema),
  }),
});
export type EntryRework = z.infer<typeof entryReworkResponseSchema>['data'];

export const reworkEventsResponseSchema = z.object({
  success: z.literal(true),
  data: z.array(reworkEventSchema),
  meta: z.object({ next_cursor: z.string().nullable() }),
});
export type ReworkEventsPage = z.infer<typeof reworkEventsResponseSchema>;
